import { gql } from '@apollo/client';

export const fetchTransactionAccountForDownloadCSV = gql`
  query fetchTransactionAccountForDownloadCSV($id: ID!) {
    transactionAccount(id: $id) {
      id
      availableInvoiceGroups {
        nodes {
          id
          shipToParty {
            name
            addressLine1
            addressLine2
            city
            state
            country
          }
          defaultPaymentMethod {
            id
            type
            paymentIssue
            ... on CreditCard {
              card {
                expirationMonth
                expirationYear
                last4Numbers
                brand
              }
            }
            ... on PaymentOnTerms {
              terms {
                invoiceDueDays
              }
            }
          }
        }
      }
    }
  }
`;
